<!-- <mat-progress-bar color="primary" mode="indeterminate" *ngIf="spinnerService.visibility | async"> -->
<div *ngIf="mediaObserver.isActive('xs'); else desktopView">
  <ng-container *ngTemplateOutlet="mobileView"></ng-container>
</div>

<!-- MOBILE -->
<ng-template #mobileView>
  <div fxLayout="row" class="side-container-top">
    <ng-container
      [ngTemplateOutlet]="sideContent"
      [ngTemplateOutletContext]="{ isMobile: true, position: 'top' }"
    ></ng-container>
  </div>
  <div class="main-container custom-height" [class.scroll]="scrollEnabled">
    <ng-container *ngTemplateOutlet="notifications"></ng-container>
    <ng-container [ngTemplateOutlet]="mainContent"></ng-container>
  </div>
  <div fxLayout="row" class="side-container-bottom">
    <ng-container
      [ngTemplateOutlet]="sideContent"
      [ngTemplateOutletContext]="{ isMobile: true, position: 'bottom' }"
    ></ng-container>
  </div>
</ng-template>

<!-- DESKTOP -->
<ng-template #desktopView>
  <div fxLayout="row">
    <div
      fxLayout="column"
      class="side-container"
      [class.hide]="!sideContentVisible"
    >
      <ng-container
        [ngTemplateOutlet]="sideContent"
        [ngTemplateOutletContext]="{ isMobile: false }"
      ></ng-container>
    </div>
    <div
      [ngClass]="fullwidth ? 'main-container-new' : 'main-container'"
      class="main-container-gt-xs custom-height-gt-xs"
      [class.scroll]="scrollEnabled"
    >
      <ng-container *ngTemplateOutlet="notificationsCounter"></ng-container>
      <ng-container *ngTemplateOutlet="notifications"></ng-container>
      <ng-container [ngTemplateOutlet]="mainContent"></ng-container>
    </div>
  </div>
</ng-template>

<!-- NOTIFICATIONS COUNTER -->
<ng-template #notificationsCounter>
  <!-- <app-notifications-counter  class="notification" ></app-notifications-counter>  -->
</ng-template>
<!-- NOTIFICATION -->
<ng-template #notifications>
  <!-- <app-notifications *ngIf="isOpen"></app-notifications> -->
</ng-template>
